import React from "react";
import { Modal } from "react-bootstrap";

const ModalComponent = ({ show, onHide, title, children }) => {
  const modalTitleStyle = {
    color: "black",
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title style={modalTitleStyle}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
